import { render } from "./App.vue?vue&type=template&id=68e6ded8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=68e6ded8&lang=css"

import exportComponent from "D:\\未知比特项目\\前端项目\\adminSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__